<template>
  <h2 class="pb-2 border-bottom">Terapias IM/IV & Infusiones de Vitaminas</h2>
  <p>Energía, Equilibrio y Bienestar desde el Interior</p>
  <p>Nuestras terapias intravenosas, realizadas bajo supervisión médica, aportan hidratación, nutrientes y antioxidantes directamente al organismo para una absorción más rápida y beneficios duraderos. Cada tratamiento está diseñado para apoyar su salud, recuperación y bienestar.</p>
  <ul>
    <li>Bienestar & hidratación — restaura el equilibrio con electrolitos, vitaminas y antioxidantes para una hidratación completa.</li>
    <li>Energía & rendimiento — B12 y aminoácidos para mayor energía, metabolismo activo y recuperación post-entrenamiento.</li>
    <li>Piel & rejuvenecimiento — combinaciones vitamínicas para la salud de la piel, el cabello y el brillo natural.</li>
    <li>Metabolismo & control de peso — infusiones personalizadas con aminoácidos y vitaminas del complejo B.</li>
    <li>IV de recuperación — rehidratación y reequilibrio tras fatiga, viajes o días de estrés.</li>
  </ul>
  <p>“Nuestras terapias son personalizadas y supervisadas — diseñadas para que se sienta renovado, lleno de energía y equilibrado.”</p>
</template>

<script>
export default {
  name: 'IMIVVitaminTherapiesContentEs'
};
</script>

<style scoped>
/* Add any component-specific styles here */
</style>
